module.exports = __webpack_public_path__ + "static/img/dataAnalysis2.61d755bc.png";